import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button as DefaultButton, Stack as DefaultStack } from '@leroy-merlin-br/backyard-react-ui'

const buttonStyles = ({ theme }) => css`
  padding: 9px ${theme.spacings.mega};
`

const stackStyles = ({ theme }) => css`
  margin: 0 auto;
  width: 85%;

  ${theme.media.mega} {
    width: 100%;
  }
`

export const Button = styled(DefaultButton)(buttonStyles)
export const Stack = styled(DefaultStack)(stackStyles)
